export default "__VITE_ASSET__BzQPvMv2__"